
define('ldsh!modules/page_listing/templates/tag', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a class="js-select-tag" data-bypass href="#">' +
((__t = ( text )) == null ? '' : __t) +
'</a>\n';

}
return __p
};});

